import React, { useEffect, useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import { FormControl, FormHelperText, TextField, Typography, InputLabel, Select, MenuItem, Button, Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { AcquirerActions, NotificationActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        "& h6": {
            fontSize: '12px'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const acquirersSelector = (state) => state.Acquirers;
const IdentitySelector = (state) => state.Identity;

const AcquirerStepFive = (props) => {

    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const acquirerActions = bindActionCreators(AcquirerActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(acquirersSelector);
    const { token } = useSelector(IdentitySelector);

    const { control, errors, handleSubmit, watch } = useForm();

    const { classes } = props;

    /**
     *
     * 入力内容変更時の処理
     *
     */
    const onChange = (e) => {
        const currentState = editing.fee_merchant_create_request;
        const { name, value } = e[0].target;

        currentState[name] = value;

        return value;
    }

    const handleNext = () => {
        props.handleNext();
    };

    const handleBack = () => {
        props.handleBack();
    };

    // 手数料管理情報_期間(開始)
    var dt = new Date(editing.fee_merchant_create_request.start_date);
    var startDate = dt.getFullYear() + '-' + ("0" + (dt.getMonth() + 1)).slice(-2) + '-' + ("0" + dt.getDate()).slice(-2);

    // 手数料管理情報_期間(終了)
    dt = new Date(editing.fee_merchant_create_request.end_date);
    var endDate = dt.getFullYear() + '-' + ("0" + (dt.getMonth() + 1)).slice(-2) + '-' + ("0" + dt.getDate()).slice(-2);

    // 範囲開始日（翌日）
    var targetDate = new Date();
    targetDate.setDate(targetDate.getDate() + 1);
    var nextDt = new Date(targetDate);
    var nextday = nextDt.toISOString().slice(0, 10);
    var minDate = nextday;
    // 範囲終了日（2199年12月31日）
    var maxDate = new Date('2199-12-31').toISOString().slice(0, 10);

    // 手数料チェック値
    var feeMaxLength = 6;
    var feeMin = 0.00;
    var feeMax = 100.00;
    //var feePattern = /^([1-9][0-9]{0,2}|0)(\.[0-9]{1,1})?$/i;
    var feePattern = /^\d{1,3}(\.\d{1,2})?$/i;

    return (
        <form className={classes.form} noValidate>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.Period"} /></InputLabel>
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="start_date"
                        control={control}
                        onChange={onChange}
                        defaultValue={startDate}
                        inputProps={{ min: minDate, max: maxDate }}
                        rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                        as={<TextField required fullWidth variant="outlined"
                            id="start_date"
                            type="date"
                            error={errors.start_date && true}
                            helperText={errors.start_date ? errors.end_date.message : "日付を設定してください。"}
                            label={<FormattedMessage id={"Merchant.FromDate"} />}
                        />}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="end_date"
                        control={control}
                        onChange={onChange}
                        defaultValue={endDate}
                        rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                        as={<TextField disabled required fullWidth variant="outlined"
                            id="end_date"
                            type="date"
                            error={errors.end_date && true}
                            helperText={errors.end_date ? errors.end_date.message : ""}
                            label={<FormattedMessage id={"Merchant.ToDate"} />}
                        />}
                    />
                </Grid>

                <Grid item xs={12}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.SystemFeeRate"} /></InputLabel>
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="system_fee_okica_card_payment"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.fee_merchant_create_request.system_fee_okica_card_payment}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                            min: { value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                            max: { value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                            pattern: { value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.system_fee_okica_card_payment && true}
                            helperText={errors.system_fee_okica_card_payment ? errors.system_fee_okica_card_payment.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />}0.0</Typography>}
                            label={<FormattedMessage id={"Merchant.OKICACardPayment"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="brand_fee_okica_card_payment"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.fee_merchant_create_request.brand_fee_okica_card_payment}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                            min: { value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                            max: { value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                            pattern: { value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.brand_fee_okica_card_payment && true}
                            helperText={errors.brand_fee_okica_card_payment ? errors.brand_fee_okica_card_payment.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />}0.0</Typography>}
                            label={<FormattedMessage id={"Merchant.BrandCharge"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="system_fee_qr_payment"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.fee_merchant_create_request.system_fee_qr_payment}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                            min: { value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                            max: { value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                            pattern: { value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.system_fee_qr_payment && true}
                            helperText={errors.system_fee_qr_payment ? errors.system_fee_qr_payment.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />}0.0</Typography>}
                            label={<FormattedMessage id={"Merchant.QRBalanceSettlement"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="brand_fee_qr_payment"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.fee_merchant_create_request.brand_fee_qr_payment}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                            min: { value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                            max: { value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                            pattern: { value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.brand_fee_qr_payment && true}
                            helperText={errors.brand_fee_qr_payment ? errors.brand_fee_qr_payment.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />}0.0</Typography>}
                            label={<FormattedMessage id={"Merchant.BrandCharge"} />} />} />
                </Grid>
                <Grid item xs={12}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.ChargeCommissionRate"} /></InputLabel>
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="merchant_fee_okica_card_charge"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.fee_merchant_create_request.merchant_fee_okica_card_charge}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                            min: { value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                            max: { value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                            pattern: { value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.merchant_fee_okica_card_charge && true}
                            helperText={errors.merchant_fee_okica_card_charge ? errors.merchant_fee_okica_card_charge.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />}0.0</Typography>}
                            label={<FormattedMessage id={"Merchant.OKICACardCharge"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="merchant_fee_okica_card_value_exchange"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.fee_merchant_create_request.merchant_fee_okica_card_value_exchange}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                            min: { value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                            max: { value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                            pattern: { value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.merchant_fee_okica_card_value_exchange && true}
                            helperText={errors.merchant_fee_okica_card_value_exchange ? errors.merchant_fee_okica_card_value_exchange.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />}0.0</Typography>}
                            label={<FormattedMessage id={"Merchant.OKICACardValue"} />} />} />
                </Grid>
                <Grid item xs={12}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.CreditFeeRate"} /></InputLabel>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth required variant="outlined" error={errors.credit_card_payment_agency_id && true}>
                        <InputLabel id="merchant-label-payment"><FormattedMessage id={"Merchant.Shop"} /></InputLabel>
                        <Controller
                            name="credit_card_payment_agency_id"
                            control={control}
                            onChange={onChange}
                            rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                            defaultValue={editing.fee_merchant_create_request.credit_card_payment_agency_id}
                            as={<Select
                                labelId="merchant-label-payment"
                                id="merchant-payment"
                                label={<FormattedMessage id={"Merchant.Shop"} />}>
                                <MenuItem value={100002}><FormattedMessage id={"Merchant.GeneralStore"} /></MenuItem>
                                <MenuItem value={100003}><FormattedMessage id={"Merchant.Taxi"} /></MenuItem>
                                <MenuItem value={100004}><FormattedMessage id={"Merchant.Retail"} /></MenuItem>
                            </Select>} />
                        <FormHelperText>{errors.credit_card_payment_agency_id ? errors.credit_card_payment_agency_id.message : ""}</FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="system_fee_credit_card_payment"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.fee_merchant_create_request.system_fee_credit_card_payment}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                            min: { value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                            max: { value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                            pattern: { value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.system_fee_credit_card_payment && true}
                            helperText={errors.system_fee_credit_card_payment ? errors.system_fee_credit_card_payment.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />}0.0</Typography>}
                            label={<FormattedMessage id={"Merchant.SystemFee"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="brand_fee_credit_card_payment"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.fee_merchant_create_request.brand_fee_credit_card_payment}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                            min: { value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                            max: { value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                            pattern: { value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.brand_fee_credit_card_payment && true}
                            helperText={errors.brand_fee_credit_card_payment ? errors.brand_fee_credit_card_payment.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />}0.0</Typography>}
                            label={<FormattedMessage id={"Merchant.BrandCharge"} />} />} />
                </Grid>
                <Grid item xs={12}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.BankChargeRate"} /></InputLabel>
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="system_fee_bank_payment"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.fee_merchant_create_request.system_fee_bank_payment}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                            min: { value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                            max: { value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                            pattern: { value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.system_fee_bank_payment && true}
                            helperText={errors.system_fee_bank_payment ? errors.system_fee_bank_payment.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 0.0</Typography>}
                            label={<FormattedMessage id={"Merchant.SystemFee"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="brand_fee_bank_payment"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.fee_merchant_create_request.brand_fee_bank_payment}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: feeMaxLength, message: <FormattedMessage id={"Error.FeeMaxLen"} /> },
                            min: { value: feeMin, message: <FormattedMessage id={"Error.FeeMin"} /> },
                            max: { value: feeMax, message: <FormattedMessage id={"Error.FeeMax"} /> },
                            pattern: { value: feePattern, message: <FormattedMessage id={"Error.FeePattern"} /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.brand_fee_bank_payment && true}
                            helperText={errors.brand_fee_bank_payment ? errors.brand_fee_bank_payment.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 0.0</Typography>}
                            label={<FormattedMessage id={"Merchant.BrandCharge"} />} />} />
                </Grid>

                <Grid item xs={6}>
                    <Button fullWidth variant="contained" size="medium"
                        startIcon={<ArrowBackIosIcon />}
                        onClick={handleBack}><FormattedMessage id="Button.Back" /></Button>
                </Grid>
                <Grid item xs={6}>
                    <Button fullWidth variant="contained" size="medium" color="primary"
                        onClick={handleSubmit(handleNext)}
                        endIcon={<ArrowForwardIosIcon />}>
                        <FormattedMessage id="Button.Next" />
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}

export default withStyles(style, { withTheme: true })(AcquirerStepFive);
